// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"818":"d5f4fdf2","3751":"d5f4fdf2","7910":"d5f4fdf2","9740":"d5f4fdf2"}[chunkId] + ".chunk.css";
};